import { useState, useEffect } from "react";
// import { sGet, sPut, sDelete } from "../../utils/adminApi";
import { sGet, sPut, sDelete } from "../../utils/staffApi";
import { C, Btn, LoadingSpinner } from "./AdminPanel";

export default function Contacts({ toast }) {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selected, setSelected] = useState(null);

    const load = () => {
        setLoading(true);
        sGet("/contacts").then(setContacts).catch(e => toast(e.message, "error")).finally(() => setLoading(false));
    };
    useEffect(load, [toast]);

    const markRead = async (id) => {
        try { await sPut(`/contacts/${id}/read`); load(); }
        catch (e) { toast(e.message, "error"); }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this message?")) return;
        try { await sDelete(`/contacts/${id}`); toast("Deleted"); load(); setSelected(null); }
        catch (e) { toast(e.message, "error"); }
    };

    const unread = contacts.filter(c => !c.isRead).length;

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <div style={{ color: C.muted, fontSize: 13 }}>
                {unread > 0 && <span style={{ color: C.red, fontWeight: 700 }}>● {unread} unread </span>}
                {contacts.length} total messages
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: 16, minHeight: 500 }}>
                {/* List */}
                <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, overflow: "hidden" }}>
                    {loading ? <LoadingSpinner /> : contacts.length === 0 ? (
                        <div style={{ padding: 40, textAlign: "center", color: C.muted }}>No messages</div>
                    ) : (
                        contacts.map(c => (
                            <div key={c._id} onClick={() => { setSelected(c); if (!c.isRead) markRead(c._id); }}
                                style={{
                                    padding: "14px 18px", borderBottom: `1px solid ${C.border}`,
                                    cursor: "pointer", background: selected?._id === c._id ? C.surface : "transparent",
                                    borderLeft: `3px solid ${c.isRead ? "transparent" : C.primary}`,
                                    transition: "background 0.1s",
                                }}>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                                    <span style={{ fontWeight: c.isRead ? 500 : 800, color: C.text, fontSize: 13 }}>{c.name}</span>
                                    <span style={{ fontSize: 11, color: C.muted }}>{new Date(c.createdAt).toLocaleDateString("en-IN")}</span>
                                </div>
                                <div style={{ fontSize: 12, color: C.muted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.email}</div>
                                <div style={{ fontSize: 12, color: C.muted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginTop: 2 }}>{c.message?.substring(0, 60)}…</div>
                            </div>
                        ))
                    )}
                </div>

                {/* Detail */}
                <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: 24 }}>
                    {!selected ? (
                        <div style={{ textAlign: "center", color: C.muted, paddingTop: 80 }}>
                            <div style={{ fontSize: 48, marginBottom: 12 }}>✉️</div>
                            Select a message to view
                        </div>
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                <div>
                                    <h3 style={{ color: C.text, fontWeight: 800, fontSize: 18 }}>{selected.name}</h3>
                                    <div style={{ color: C.muted, fontSize: 13 }}>{selected.email}</div>
                                    {selected.phone && <div style={{ color: C.muted, fontSize: 13 }}>📞 {selected.phone}</div>}
                                </div>
                                <Btn variant="red" size="sm" onClick={() => handleDelete(selected._id)}>🗑 Delete</Btn>
                            </div>
                            {selected.subject && (
                                <div style={{ background: C.surface, borderRadius: 8, padding: "10px 14px" }}>
                                    <div style={{ fontSize: 11, color: C.muted, fontWeight: 600, marginBottom: 4 }}>SUBJECT</div>
                                    <div style={{ fontWeight: 600, color: C.text }}>{selected.subject}</div>
                                </div>
                            )}
                            <div style={{ background: C.surface, borderRadius: 8, padding: "14px 16px" }}>
                                <div style={{ fontSize: 11, color: C.muted, fontWeight: 600, marginBottom: 8 }}>MESSAGE</div>
                                <p style={{ color: C.text, fontSize: 14, lineHeight: 1.8 }}>{selected.message}</p>
                            </div>
                            <div style={{ fontSize: 11, color: C.muted }}>{new Date(selected.createdAt).toLocaleString("en-IN")}</div>
                            <a href={`mailto:${selected.email}?subject=Re: ${selected.subject || "Your enquiry"}`}
                                style={{ display: "inline-block", textDecoration: "none" }}>
                                <Btn>✉️ Reply via Email</Btn>
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}